import styled from '@emotion/styled'
import { css } from '@emotion/react'

const thumbnailInfoStyles = ({ theme }) => css`
  label: thumbnail__info;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  position: absolute;
  top: 44px;

  height: 40%;

  padding: ${theme.spacings.kilo} ${theme.spacings.mega};

  h4 {
    color: ${theme.colors.white};

    flex-basis: 100%;

    font-size: ${theme.typography.headings.tera.fontSize};
    font-weight: ${theme.font.weight.bold};
    line-height: ${theme.typography.headings.tera.lineHeight};

    margin: 0;
  }

  .author {
    color: ${theme.colors.white};
    flex-basis: 82%;
    font-size: ${theme.typography.text.kilo.fontSize};
  }
`

export const ThumbnailInfo = styled('div')(thumbnailInfoStyles)
